export default (element) => {
  const readmore = element.querySelector('[data-readmore]');
  const readless = element.querySelector('[data-readless]');
  const showmore = element.querySelector('[data-showmore]');
  const showless = element.querySelector('[data-showless]');
  const toggleReadmore = () => {
    showmore.style.display = 'none';
    showless.classList.remove("hidden");
  };

  const toggleReadless = () => {
    showmore.style.display = 'block';
    showless.classList.add("hidden");
  };

  const init = () => {
    if (readmore) readmore.addEventListener('click', () => toggleReadmore());
    if (readless) readless.addEventListener('click', () => toggleReadless());
  }

  init();
};